import { Color } from 'src/styles';

import { MTypography } from '../MTypography/MTypography';

import * as Styles from './ClosedOffersTag.styles';

export const ClosedOffersTag = () => {
  return (
    <div className={Styles.closedOfferBadge}>
      <MTypography variant='h5' weight='semibold' color={Color.Red7} className={Styles.closedOfferTitle}>
        *Closed Offers
      </MTypography>
      <MTypography variant='body1'>
        Closed Offer may include capital raised by other selling group members or placement agents, unless My IPO is the
        sole placement agent.
      </MTypography>
      <MTypography variant='body1'>
        All capital amounts above reflect the total amount each Company raised in their offering.
      </MTypography>
      <MTypography variant='body1'>
        Through December 31, 2024, offers were available through Cambria Capital, LLC dba My IPO. As of January 2, 2025,
        offers were available through AOS, Inc. dba My IPO, a FINRA member broker-dealer.
      </MTypography>
    </div>
  );
};
